import { render } from "./HeaderDark.vue?vue&type=template&id=7ac833ac"
import script from "./HeaderDark.vue?vue&type=script&lang=js"
export * from "./HeaderDark.vue?vue&type=script&lang=js"

import "./HeaderDark.vue?vue&type=style&index=0&id=7ac833ac&lang=scss"
script.render = render

export default script